var Projet_Primes = {
	init:function(){
		$(window).resize(function(){
			Projet_Primes.resize();
		});
		
		Projet_Primes.resize();
	},
	create_carousel:function(){
		
		
		var _carousel = $(".product-prime .list-primes");
		
		var _slides_to_show = 1;
		var els = document.querySelectorAll(".list-primes");

		Array.prototype.forEach.call(els, function(el) {
			//Debug.log("SLIDES TO SHOW : " + el + " => " + parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide")));
			
			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
			
		});

		

		_carousel.slick({
			arrows:false, 
			dots:true,
			infinite: false,
			variableWidth:true,
			slidesToShow: _slides_to_show,
			slidesToScroll:2,
			focusOnSelect: true,
			touchThreshold:500
		});	
		
		
	},
	delete_carousel:function(){
		var _carousel = $(".product-prime .list-primes");

		if (_carousel.hasClass('slick-initialized')) {
			_carousel.slick('unslick');
		}

	},
	resize:function(){
		Projet_Primes.delete_carousel();
		Projet_Primes.create_carousel();
		
		 $(".product-prime .slick-track").css({transform:"translate3d(0, 0, 0)"});
	}
}

$(window).load(function(){
	if($(".product-prime").length){
		Projet_Primes.init();
	}
})